export const toAPIDate = (date) => date ? new Date(date).toISOString() : null;
